import AlbumManualMatchingHeader from './AlbumManualMatchingHeader';

export default AlbumManualMatchingHeader;
